import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.15_@babel+core@7.28.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavMenu"] */ "/vercel/path0/shared/components/client/NavMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResponsiveHeader"] */ "/vercel/path0/shared/components/client/ResponsiveHeader.tsx");
